import tw, { css, styled } from "twin.macro";
import { type SkeletonProps } from ".";
import IconPhotoCamera from "@iconsV2/Devices/photo-camera-02.svg?react";

interface ISkeleton {
  $animate?: SkeletonProps["animate"];
  $type: SkeletonProps["type"];
  $width?: SkeletonProps["width"];
  $height: SkeletonProps["height"];
  $backgroud?: SkeletonProps["backgroud"];
  $borderRadius?: SkeletonProps["borderRadius"];
  $opacity?: SkeletonProps["opacity"];
}
interface StyledGalleryContentProps {
  $withBorder?: boolean;
}
const styles = {
  types: {
    image: tw`bg-primaryV2-90 flex items-center justify-center`,
    gallery: tw`bg-primaryV2-90 p-xl rounded-[8px]`,
    text: tw`bg-primaryV2-70`,
    button: tw`bg-cta-shopping-default rounded-[6.25rem]`,
    card: tw`bg-transparent  border border-primaryV2-85  rounded-[0.5rem]`,
  },
};

export const StyledSkeleton = styled.div<ISkeleton>`
  ${({ $animate }) => $animate && tw`animate-pulse1`}
  ${({ $type }) => styles.types[$type]}
${({ $width, $height, $backgroud, $borderRadius, $opacity }) => css`
    width: ${$width};
    height: ${$height};
    background: ${$backgroud};
    border-radius: ${$borderRadius};
    opacity: ${$opacity};
  `}
`;

export const StyledGalleryContent = styled.div<StyledGalleryContentProps>`
  ${tw`w-full h-full rounded-[8px] flex items-center justify-center`}

  ${({ $withBorder }) => $withBorder && tw`border-2 border-primaryV2-50`}
`;

export const StyledPhotoCamera = styled(IconPhotoCamera)`
  ${tw`fill-primaryV2-50 w-[33px] h-[33px] medium:(h-[60px] w-[60px]) large:(h-[73px] w-[73px])`}
`;
